export default "https://legacy.eskolare-development.com/images/bank-empty.png";